import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { environment } from 'src/environments/environment';
import { OrganisationDataSource } from 'src/modules/organisation/services/organisation-data-source';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { UserApiService } from 'src/modules/user/services/user-api.service';
import { OrganisationAdminApiService } from '../../services/organisation-admin-api-service';
import { CreateOrgansation } from '../organisation/create/component';
import { OrganisationsMemberList } from '../organisation/member-list/component';
import { AccountCodeEdit } from '../organisation/modals/create/component';

@Component({
  selector: 'organisation-admin-dashboard',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  standalone: false,
})
export class OrganisationDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;

  public loading: boolean;
  public search: string;
  public Organisations: IOrganisation[];
  public leisureUrl: string = environment.leisureUrl;
  public PageEvent: NgPageEvent;
  public filter: {};
  public isSuperAdmin: boolean;
  public userId: number = 0;

  public DataSource: OrganisationDataSource;
  private Subscriptions: RxSubscription[] = [];

  public displayedColumns = ['title', 'actions'];
  constructor(
    private OrganisationAdminApi: OrganisationAdminApiService,
    private Auth: AuthService,
    private Router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.isSuperAdmin = this.Auth.inGroup('superadmin');
    const { id } = this.Auth.getLoggedInUser();
    this.userId = id;
    const role = `organisation-admin`;
    this.DataSource = new OrganisationDataSource(
      role,
      this.OrganisationAdminApi,
      this.userId,
    );
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading)),
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (Organisations) => (this.Organisations = Organisations),
      ),
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (PageEvent) => (this.PageEvent = PageEvent),
      ),
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe((filter) => {
        this.filter = filter;
        this.DataSource.loadWithPageEvent(this.PageEvent);
      }),
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  public viewOrganisation(organisation) {
    const id = organisation.company_id
      ? organisation.company_id
      : organisation.id;
    this.Router.navigate([`/organisations/${id}`], {
      state: { data: organisation, role: 'organisation-admin' },
    });
  }
  // public listListings(Organisation: Organisation) {
  //   const config = new MatDialogConfig();

  //   config.data = Organisation;
  //   config.disableClose = true;

  //   this.dialog.open(ListingsList, config);
  // }

  // public listEvents(Organisation: Organisation) {
  //   const config = new MatDialogConfig();

  //   config.data = Organisation;
  //   config.disableClose = true;

  //   this.dialog.open(EventsList, config);
  // }

  public listMembers(Organisation: IOrganisation) {
    const config = new MatDialogConfig();
    config.data = Organisation;
    return this.dialog.open(OrganisationsMemberList, config);
  }

  public addNewOrg() {
    const config = new MatDialogConfig();
    config.data = { DataSource: this.DataSource };
    config.disableClose = true;

    this.dialog
      .open(CreateOrgansation, config)
      .afterClosed()
      .subscribe((org) => {
        this.viewOrganisation(org[0]);
      });
  }

  public viewAccountCode(Organisation: IOrganisation) {
    const DialogConfig = new MatDialogConfig();
    const data = { Organisation, OrganisationDataSource: this.DataSource };
    DialogConfig.disableClose = true;
    DialogConfig.data = data;

    this.Subscriptions.push(
      this.dialog
        .open(AccountCodeEdit, DialogConfig)
        .afterClosed()
        .subscribe(() => {
          this.DataSource.loadWithPageEvent(this.PageEvent);
        }),
    );
  }

  public downloadOrderReport(Organisation: IOrganisation) {
    this.OrganisationAdminApi.downloadOrderReport(
      'organisation-admin',
      Organisation.company_id,
    ).then((data) => {
      const binaryString = atob(data.orders);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const file = new File([bytes], 'orders.csv', { type: 'text/csv' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(file);
      a.download = file.name;
      a.click();
    });
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
